export default __webpack_public_path__ + "static/media/auraofinfusion.285b5ea6.png";